            <template>

  <div class="knowledge-practice-container">

    <!-- 顶部导航栏 -->

    <div class="practice-header">

      <div class="header-left">

        <i class="el-icon-arrow-left back-btn" @click="goBack"></i>

        <h1 class="practice-title">知识点精练</h1>

      </div>

      <div class="header-right">

        <el-button

          type="primary"

          size="small"

          icon="el-icon-refresh"

          @click="refreshKnowledge"

          class="refresh-btn">

          刷新

        </el-button>

      </div>

    </div>

    <!-- 加载状态 -->

    <div v-if="loading" class="loading-container">

      <el-loading

        :loading="loading"

        text="正在加载知识点..."

        background="rgba(0, 0, 0, 0.8)"

      />

    </div>

    <!-- 错误状态 -->

    <div v-else-if="error" class="error-container">

      <div class="error-content">

        <i class="el-icon-warning error-icon"></i>

        <p class="error-message">{{ error }}</p>

        <el-button type="primary" @click="refreshKnowledge">重新加载</el-button>

      </div>

    </div>

    <!-- 知识点列表 -->

    <div v-else-if="knowledgeTree.length > 0" class="knowledge-content">

      <!-- 统计信息 -->

      <div class="stats-section">

        <div class="stat-card">

          <div class="stat-number">{{ knowledgeCount }}</div>

          <div class="stat-label">知识点总数</div>

        </div>

        <div class="stat-card">

          <div class="stat-number">{{ questionCount }}</div>

          <div class="stat-label">题目总数</div>

        </div>

        <div class="stat-card">

          <div class="stat-number">{{ completedCount }}</div>

          <div class="stat-label">已完成</div>

        </div>

        <div class="stat-card">

          <div class="stat-number">{{ Math.round((completionRate || 0) * 100) }}%</div>

          <div class="stat-label">完成率</div>

        </div>

        <!-- <div class="stat-card">

          <div class="stat-number">{{ correctCount }}</div>

          <div class="stat-label">正确数</div>

        </div>

        <div class="stat-card">

          <div class="stat-number">{{ Math.round((accuracyRate || 0) * 100) }}%</div>

          <div class="stat-label">正确率</div>

        </div> -->

      </div>

      <!-- 面包屑导航 -->
      <div class="breadcrumb-nav" v-if="currentPath.length > 0">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item>
            <a @click="navigateToLevel(null)">全部知识点</a>
          </el-breadcrumb-item>
          <el-breadcrumb-item v-for="(item, idx) in currentPath" :key="item.key">
            <a v-if="idx < currentPath.length - 1" @click="navigateToLevel(item)">{{ item.label }}</a>
            <span v-else>{{ item.label }}</span>
          </el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <!-- 知识点卡片网格 -->
      <div class="knowledge-grid">
        <div
          v-for="(knowledge, index) in currentLevelNodes"
          :key="knowledge.key || index"
          class="knowledge-card"
          :class="{
            'completed': knowledge.completed,
            'is-other': knowledge.isOther,
            'locked': isKnowledgeLocked(knowledge, index)
          }"
        >
          <div class="card-header">
            <div class="knowledge-title">
              <i v-if="isKnowledgeLocked(knowledge, index)" class="el-icon-lock" style="margin-right:6px;color:#f56c6c;"></i>
              <i v-else-if="knowledge.isOther" class="el-icon-collection-tag" style="margin-right:6px;color:#909399;"></i>
              {{ knowledge.label }}
            </div>
            <div class="completion-status">
              <i v-if="knowledge.completed && !isKnowledgeLocked(knowledge, index)" class="el-icon-check completed-icon"></i>
            </div>
          </div>

          <div class="card-content">
            <div class="knowledge-subject">{{ knowledge.subject || '数学' }}</div>
            <div class="question-count">
              <i class="el-icon-document"></i>
              <span>{{ knowledge.total || 0 }} 道题</span>
            </div>
          </div>

          <div class="card-footer">
            <div class="difficulty-level">
              <span class="difficulty-label">完成度:</span>
              <el-progress
                :percentage="knowledge.progress || 0"
                :stroke-width="10"
                :status="(knowledge.progress || 0) === 100 ? 'success' : undefined"
                style="width: 140px;"
              />
            </div>
          </div>

          <div class="card-actions">
            <el-button
              v-if="hasChildren(knowledge)"
              :type="isKnowledgeLocked(knowledge, index) ? 'info' : 'primary'"
              size="small"
              @click="isKnowledgeLocked(knowledge, index) ? showMemberTip() : navigateToLevel(knowledge)"
              :icon="isKnowledgeLocked(knowledge, index) ? 'el-icon-lock' : 'el-icon-arrow-right'"
              :disabled="isKnowledgeLocked(knowledge, index)"
            >
              {{ isKnowledgeLocked(knowledge, index) ? '会员专享' : '查看子知识点' }}
            </el-button>
            <el-button
              :type="isKnowledgeLocked(knowledge, index) ? 'info' : 'success'"
              size="small"
              @click="isKnowledgeLocked(knowledge, index) ? showMemberTip() : startPractice(knowledge)"
              :icon="isKnowledgeLocked(knowledge, index) ? 'el-icon-lock' : 'el-icon-edit'"
              :disabled="isKnowledgeLocked(knowledge, index)"
            >
              {{ isKnowledgeLocked(knowledge, index) ? '会员专享' : '开始练习' }}
            </el-button>
          </div>
        </div>
      </div>

    </div>

    <!-- 空状态 -->

    <div v-else class="empty-container">

      <div class="empty-content">

        <i class="el-icon-document empty-icon"></i>

        <p class="empty-message">暂无知识点数据</p>

        <el-button type="primary" @click="refreshKnowledge">重新加载</el-button>

      </div>

    </div>

  </div>

</template>

<script>

import { listGeneralKnowledgeTree, getKnowledgeProgressByRepoId } from '@/api/knowledge'

import { getActivePlan } from '@/api/studyPlan'

import { getTokenInfo } from '@/utils/jwtUtils'

export default {

  name: 'KnowledgePractice',

  data() {
    return {

      // 加载状态

      loading: false,

      // 错误信息

      error: null,

      // 知识点树

      knowledgeTree: [],

      // 当前层级路径（面包屑）
      currentPath: [],

      // 当前显示的节点（null表示顶层）
      currentParentNode: null,

      // 题目总数（从进度接口获取）

      questionCount: 0,

      // 当前使用的题库ID
      currentRepoId: null,

      // 当前来源
      currentSource: 'general',

      // 非会员可访问的顶层知识点数量限制，0 表示不限制
      accessLimit: 0,

      // 用户学习计划信息（通用）
      userPlanInfo: null,

      // 已完成数量

      completedCount: 0,

      // 正确数量

      correctCount: 0,

      // 完成率与正确率（0-1）

      completionRate: 0,

      accuracyRate: 0

    }
  },

  computed: {
    knowledgeCount() {
      return this.countNonOtherNodes(this.knowledgeTree)
    },

    // 当前层级显示的节点列表
    currentLevelNodes() {
      if (!this.currentParentNode) {
        return this.knowledgeTree
      }
      return this.currentParentNode.children || []
    }
  },

  created() {
    this.hideSidebarAndNavbar()

    this.loadKnowledgeData()
  },

  beforeDestroy() {
    this.showSidebarAndNavbar()
  },

  methods: {

    // 隐藏侧边栏和导航栏

    hideSidebarAndNavbar() {
      this.$store.dispatch('app/closeSideBar', { withoutAnimation: false })

      const sidebar = document.querySelector('.sidebar-container')

      const navbar = document.querySelector('.navbar')

      if (sidebar) {
        sidebar.style.display = 'none'
      }

      if (navbar) {
        navbar.style.display = 'none'
      }

      const appMain = document.querySelector('.app-main')

      if (appMain) {
        appMain.style.padding = '0'

        appMain.style.margin = '0'
      }
    },

    // 计算所有顶层知识点完成度（改为直接使用后端进度数据）

    async computeProgressForAll(progressData) {
      if (!Array.isArray(this.knowledgeTree) || this.knowledgeTree.length === 0) return

      const list = Array.isArray(progressData?.knowledgeList) ? progressData.knowledgeList : []
      const byId = new Map(list.map(i => [Number(i.id), i]))

      const attach = (n) => {
        if (!n || n.isOther) return
        const p = byId.get(Number(n.id)) || {}
        const total = Number(p.total || 0)
        const completedNum = Number(p.completed || 0)
        const correctNum = Number(p.correct || 0)
        const progress = total > 0 ? Math.round((completedNum / total) * 100) : 0
        const completed = completedNum >= total && total > 0
        n.total = total
        n.completedNum = completedNum
        n.correctNum = correctNum
        n.progress = progress
        n.completed = completed
        if (Array.isArray(n.children)) n.children.forEach(attach)
      }

      this.knowledgeTree.forEach(attach)
    },

    buildOtherNodes() {
      const sumChildTotals = (children) => {
        if (!Array.isArray(children) || children.length === 0) return 0
        return children
          .filter(c => c && !c.isOther)
          .map(c => Number(c.total || 0))
          .reduce((a, b) => a + b, 0)
      }

      const walk = (n) => {
        if (!n || n.isOther) return
        if (Array.isArray(n.children) && n.children.length > 0) {
          n.children.forEach(walk)
          const total = Number(n.total || 0)
          const childTotal = sumChildTotals(n.children)
          const direct = total - childTotal
          const hasOther = n.children.some(c => c && c.isOther)
          if (direct > 0 && !hasOther) {
            n.children.push({
              key: `other-${n.id}`,
              id: n.id,
              parentId: n.id,
              parentLabel: n.label,
              label: '其他',
              isOther: true,
              progress: 0,
              completed: false,
              total: direct
            })
          }
        }
      }

      this.knowledgeTree.forEach(walk)
    },

    filterEmptyKnowledgeNodes(list) {
      if (!Array.isArray(list)) return []
      return list.reduce((result, node) => {
        if (!node) return result
        const nextNode = { ...node }
        if (Array.isArray(nextNode.children) && nextNode.children.length > 0) {
          nextNode.children = this.filterEmptyKnowledgeNodes(nextNode.children)
        }
        const total = Number(nextNode.total || 0)
        const hasChildren = Array.isArray(nextNode.children) && nextNode.children.length > 0
        if (total > 0 || hasChildren) {
          result.push(nextNode)
        }
        return result
      }, [])
    },

    countNonOtherNodes(list) {
      if (!Array.isArray(list)) return 0
      let cnt = 0
      const walk = (n) => {
        if (!n) return
        if (!n.isOther) cnt += 1
        if (Array.isArray(n.children)) n.children.forEach(walk)
      }
      list.forEach(walk)
      return cnt
    },

    // 恢复侧边栏和导航栏

    showSidebarAndNavbar() {
      this.$store.dispatch('app/openSideBar', { withoutAnimation: false })

      const sidebar = document.querySelector('.sidebar-container')

      const navbar = document.querySelector('.navbar')

      if (sidebar) {
        sidebar.style.display = ''
      }

      if (navbar) {
        navbar.style.display = ''
      }

      const appMain = document.querySelector('.app-main')

      if (appMain) {
        appMain.style.padding = ''

        appMain.style.margin = ''
      }
    },

    // 加载知识点数据

    async loadKnowledgeData() {
      this.loading = true

      this.error = null

      try {
        // 获取当前用户ID
        const userInfo = getTokenInfo()
        const userId = userInfo ? userInfo.id : null

        if (!userId) {
          throw new Error('无法获取用户信息，请重新登录')
        }

        this.currentRepoId = null
        this.currentSource = 'general'

        const routeRepoId = this.$route && this.$route.query && this.$route.query.repoId
          ? Number(this.$route.query.repoId)
          : null

        let effectiveRepoId = routeRepoId
        if (!effectiveRepoId) {
          const planResponse = await getActivePlan(userId)
          const planData = planResponse?.data?.data ?? planResponse?.data ?? planResponse
          if (!planData || !planData.repoId) {
            throw new Error('用户未选择题库，无法获取知识点')
          }
          this.userPlanInfo = { repoId: planData.repoId, ...planData }
          effectiveRepoId = planData.repoId
        } else {
          this.userPlanInfo = { repoId: effectiveRepoId }
        }
        this.currentRepoId = effectiveRepoId

        const knowledgeResponse = await listGeneralKnowledgeTree(effectiveRepoId)
        let progressResponse = {}
        try {
          progressResponse = await getKnowledgeProgressByRepoId(effectiveRepoId)
        } catch (progressErr) {
          console.warn('通用进度接口失败，继续渲染知识点:', progressErr)
          progressResponse = {}
        }

        console.log('知识点数据:', knowledgeResponse)
        console.log('进度数据响应:', progressResponse)

        // 处理知识点数据（兼容 request 拦截器返回的不同形态）
        const rawKnowledge = knowledgeResponse
        const knowledgeData = Array.isArray(rawKnowledge)
          ? rawKnowledge
          : (Array.isArray(rawKnowledge?.data)
              ? rawKnowledge.data
              : (Array.isArray(rawKnowledge?.data?.data) ? rawKnowledge.data.data : []))

        if (knowledgeData && knowledgeData.length > 0) {
          console.log('原始知识点数据数量:', knowledgeData.length)
          console.log('原始知识点数据:', knowledgeData)

          const mapNode = (item, parent) => {
            const label = item.content || item.name || item.title || '未命名'
            const n = {
              key: String(item.id),
              id: item.id,
              label,
              points: label,
              subject: item.courseType || item.subject || '数学',
              isOther: false,
              parentId: parent ? parent.id : null,
              parentLabel: parent ? parent.label : null,
              children: []
            }
            if (Array.isArray(item.children) && item.children.length > 0) {
              n.children = item.children.map(c => mapNode(c, n))
            }
            return n
          }

          this.knowledgeTree = knowledgeData.map(x => mapNode(x, null))

          this.accessLimit = this.$route && this.$route.query && this.$route.query.limit
            ? Number(this.$route.query.limit) || 0
            : 0

          // 将后端进度映射到知识点
          const payload = (progressResponse && typeof progressResponse === 'object')
            ? ((progressResponse.data && typeof progressResponse.data === 'object') ? progressResponse.data : progressResponse.data)
            : {}

          this.questionCount = Number(payload.totalCount || 0)
          this.completedCount = Number(payload.completedCount || 0)
          this.correctCount = Number(payload.correctCount || 0)
          this.completionRate = Number(payload.completionRate || 0)
          this.accuracyRate = Number(payload.accuracyRate || 0)

          await this.computeProgressForAll(payload)
          // 构建“其他”节点：用于承载仅标到父级（没有更深子级）的题目
          this.buildOtherNodes()
          this.knowledgeTree = this.filterEmptyKnowledgeNodes(this.knowledgeTree)
        } else {
          // 如果指定了repoId但查询结果为空，显示明确的错误提示
          if (effectiveRepoId) {
            throw new Error(`没有找到题库ID为 ${effectiveRepoId} 的知识点数据，请检查题库配置`)
          }
          this.knowledgeTree = []
        }
      } catch (error) {
        console.error('加载知识点失败:', error)

        this.error = error.message || '加载知识点失败，请稍后重试'

        this.knowledgeTree = []
      } finally {
        this.loading = false
      }
    },

    // 计算已完成数量

    calculateCompletedCount() {
      const list = Array.isArray(this.knowledgeTree) ? this.knowledgeTree : []
      let cnt = 0
      const walk = (n) => {
        if (!n || n.isOther) return
        if (n.completed) cnt += 1
        if (Array.isArray(n.children)) n.children.forEach(walk)
      }
      list.forEach(walk)
      this.completedCount = cnt
    },

    // 获取随机难度（临时方法，实际应该从API获取）

    getRandomDifficulty() {
      return Math.floor(Math.random() * 3) + 1
    },

    // 刷新知识点

    refreshKnowledge() {
      this.loadKnowledgeData()
    },

    // 导航到指定层级
    navigateToLevel(node) {
      if (!node) {
        // 返回顶层
        this.currentParentNode = null
        this.currentPath = []
        return
      }

      // 找到该节点在路径中的位置
      const idx = this.currentPath.findIndex(n => n.key === node.key)
      if (idx >= 0) {
        // 点击的是路径中的节点，截断路径
        this.currentPath = this.currentPath.slice(0, idx + 1)
        this.currentParentNode = node
      } else {
        // 进入子级
        this.currentPath.push(node)
        this.currentParentNode = node
      }
    },

    // 判断节点是否有子节点
    hasChildren(node) {
      return node && Array.isArray(node.children) && node.children.length > 0
    },

    isKnowledgeLocked(node, index) {
      const limit = Number(this.accessLimit || 0)
      if (!node || limit <= 0) return false
      if (!this.currentParentNode) {
        return Number(index) >= limit
      }
      const rootKey = this.getRootKnowledgeKey(node)
      const rootNodes = Array.isArray(this.knowledgeTree) ? this.knowledgeTree : []
      const rootIndex = rootNodes.findIndex(item => String(item && item.key) === String(rootKey))
      return rootIndex >= limit
    },

    getRootKnowledgeKey(node) {
      if (!node) return ''
      let current = node
      let parentId = current.parentId
      while (parentId != null) {
        const parent = this.findKnowledgeNodeById(parentId, this.knowledgeTree)
        if (!parent) break
        current = parent
        parentId = parent.parentId
      }
      return current.key
    },

    findKnowledgeNodeById(id, list) {
      if (id == null || !Array.isArray(list)) return null
      for (const item of list) {
        if (!item) continue
        if (String(item.id) === String(id)) return item
        if (Array.isArray(item.children) && item.children.length > 0) {
          const found = this.findKnowledgeNodeById(id, item.children)
          if (found) return found
        }
      }
      return null
    },

    // 开始练习：直接跳转，由目标页按知识点与题库拉取题目

    startPractice(knowledge) {
      console.log('开始练习知识点:', knowledge)

      if (knowledge && knowledge.isOther) {
        this.$router.push({
          path: '/knowledge-question-practice',
          query: {
            knowledge: (knowledge.parentLabel ? (knowledge.parentLabel + ' - 其他') : '其他'),
            otherParentId: knowledge.parentId,
            repoId: this.currentRepoId,
            source: 'general'
          }
        })
        return
      }

      this.$router.push({
        path: '/knowledge-question-practice',
        query: {
          knowledge: knowledge.points || knowledge.label,
          knowledgeId: knowledge.id,
          repoId: this.currentRepoId,
          source: 'general'
        }
      })
    },

    // 返回上一页

    goBack() {
      this.$router.go(-1)
    },

    // 显示会员提示
    showMemberTip() {
      this.$confirm('此知识点为会员专享内容，开通会员后可查看全部知识点并进行练习。', '会员专享', {
        confirmButtonText: '开通会员',
        cancelButtonText: '暂不开通',
        type: 'warning'
      }).then(() => {
        // 跳转到会员购买页面或返回课程中心
        this.$router.push('/amc-course')
      }).catch(() => {})
    }

  }

}

</script>

<style scoped>

.knowledge-practice-container {

  min-height: 100vh;

  background-color: #f5f7fa;

  padding: 0;

  margin: 0;

  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;

}

/* 顶部导航栏 */

.practice-header {

  background: #fff;

  padding: 15px 20px;

  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  position: sticky;

  top: 0;

  z-index: 100;

  display: flex;

  justify-content: space-between;

  align-items: center;

}

.header-left {

  display: flex;

  align-items: center;

  gap: 15px;

}

.header-right {

  display: flex;

  align-items: center;

}

.back-btn {

  font-size: 20px;

  color: #666;

  cursor: pointer;

  padding: 5px;

  border-radius: 50%;

  transition: background-color 0.3s;

}

.back-btn:hover {

  background-color: #f5f5f5;

}

.practice-title {

  margin: 0;

  font-size: 18px;

  font-weight: 600;

  color: #333;

}

.refresh-btn {

  background: linear-gradient(135deg, #667eea, #764ba2);

  border: none;

  border-radius: 20px;

  padding: 8px 16px;

  font-size: 14px;

  font-weight: 500;

  transition: all 0.3s ease;

  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);

}

.refresh-btn:hover {

  transform: translateY(-1px);

  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);

}

/* 加载状态 */

.loading-container {

  display: flex;

  justify-content: center;

  align-items: center;

  min-height: 400px;

}

/* 错误状态 */

.error-container {

  display: flex;

  justify-content: center;

  align-items: center;

  min-height: 400px;

}

.error-content {

  text-align: center;

  padding: 40px;

}

.error-icon {

  font-size: 48px;

  color: #f56c6c;

  margin-bottom: 20px;

}

.error-message {

  font-size: 16px;

  color: #666;

  margin-bottom: 20px;

}

/* 空状态 */

.empty-container {

  display: flex;

  justify-content: center;

  align-items: center;

  min-height: 400px;

}

.empty-content {

  text-align: center;

  padding: 40px;

}

.empty-icon {

  font-size: 48px;

  color: #c0c4cc;

  margin-bottom: 20px;

}

.empty-message {

  font-size: 16px;

  color: #666;

  margin-bottom: 20px;

}

/* 统计信息 */

.stats-section {

  display: flex;

  gap: 20px;

  padding: 20px;

  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);

  color: white;

}

.stat-card {

  flex: 1;

  background: rgba(255, 255, 255, 0.15);

  border-radius: 12px;

  padding: 20px;

  text-align: center;

  backdrop-filter: blur(10px);

}

.stat-number {

  font-size: 32px;

  font-weight: bold;

  margin-bottom: 8px;

}

.stat-label {

  font-size: 14px;

  opacity: 0.9;

}

/* 知识点网格 */

.knowledge-content {

  padding: 20px;

}

.knowledge-grid {

  display: grid;

  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));

  gap: 20px;

  margin-top: 20px;

}

.knowledge-card {

  background: #fff;

  border-radius: 12px;

  padding: 20px;

  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  cursor: pointer;

  transition: all 0.3s ease;

  border: 2px solid transparent;

}

.knowledge-card:hover {

  transform: translateY(-4px);

  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);

  border-color: #667eea;

}

.knowledge-card.completed {

  background: linear-gradient(135deg, #e8f5e8, #f0f9f0);

  border-color: #67c23a;

}

.knowledge-card.is-top {

  border-left: 4px solid #667eea;

}

.knowledge-card.is-child {

  margin-left: 20px;

  border-left: 4px solid #e0e0e0;

  background: #fafafa;

}

.knowledge-card.is-child:hover {

  border-left-color: #667eea;

}

.card-header {

  display: flex;

  justify-content: space-between;

  align-items: center;

  margin-bottom: 15px;

}

.knowledge-title {

  font-size: 16px;

  font-weight: 600;

  color: #333;

  flex: 1;

}

.child-indicator {

  color: #999;

  margin-right: 8px;

  font-weight: normal;

}

.parent-tag {

  font-size: 11px;

  color: #667eea;

  background: rgba(102, 126, 234, 0.08);

  padding: 3px 8px;

  border-radius: 10px;

  display: inline-flex;

  align-items: center;

  gap: 4px;

  margin-bottom: 8px;

  margin-top: 4px;

}

.parent-tag i {

  font-size: 12px;

}

.completion-status {

  width: 24px;

  height: 24px;

  display: flex;

  align-items: center;

  justify-content: center;

}

.completed-icon {

  color: #67c23a;

  font-size: 18px;

}

.arrow-icon {

  color: #999;

  font-size: 14px;

}

.card-content {

  margin-bottom: 15px;

}

.knowledge-subject {

  font-size: 12px;

  color: #667eea;

  background: rgba(102, 126, 234, 0.1);

  padding: 4px 8px;

  border-radius: 12px;

  display: inline-block;

  margin-bottom: 8px;

}

.knowledge-grade {

  font-size: 11px;

  color: #999;

  background: rgba(153, 153, 153, 0.1);

  padding: 2px 6px;

  border-radius: 8px;

  display: inline-block;

  margin-bottom: 8px;

}

.knowledge-description {

  font-size: 14px;

  color: #666;

  line-height: 1.4;

}

.card-footer {

  display: flex;

  justify-content: space-between;

  align-items: center;

}

.difficulty-level {

  display: flex;

  align-items: center;

  gap: 8px;

}

.difficulty-label {

  font-size: 12px;

  color: #999;

}

/* 响应式设计 */

@media (max-width: 768px) {

  .practice-header {

    padding: 10px 15px;

    flex-direction: column;

    gap: 10px;

  }

  .header-left {

    width: 100%;

    justify-content: space-between;

  }

  .header-right {

    width: 100%;

    justify-content: center;

  }

  .stats-section {

    flex-direction: column;

    gap: 15px;

    padding: 15px;

  }

  .knowledge-grid {

    grid-template-columns: 1fr;

    gap: 15px;

  }

  .knowledge-content {

    padding: 15px;

  }

}

@media (max-width: 480px) {

  .stat-number {

    font-size: 24px;

  }

  .knowledge-card {

    padding: 15px;

  }

  .knowledge-title {

    font-size: 14px;

  }

}

.breadcrumb-nav {
  margin-bottom: 24px;
  padding: 20px 24px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  border-left: 6px solid #667eea;
}

.breadcrumb-nav >>> .el-breadcrumb {
  font-size: 18px;
  line-height: 1.5;
  display: flex;
  align-items: center;
}

.breadcrumb-nav >>> .el-breadcrumb__separator {
  margin: 0 8px;
  color: #c0c4cc;
  font-weight: normal;
}

.breadcrumb-nav a {
  display: inline-block;
  padding: 6px 16px;
  background: rgba(102, 126, 234, 0.1);
  color: #667eea;
  border-radius: 6px;
  font-weight: 600;
  transition: all 0.3s ease;
  text-decoration: none;
}

.breadcrumb-nav a:hover {
  background: #667eea;
  color: #fff;
  box-shadow: 0 4px 10px rgba(102, 126, 234, 0.3);
  transform: translateY(-2px);
  text-decoration: none;
}

.breadcrumb-nav >>> .el-breadcrumb__item:last-child .el-breadcrumb__inner {
  display: inline-block;
  padding: 6px 16px;
  background: #f5f7fa;
  color: #303133;
  border-radius: 6px;
  font-weight: 700;
  border: 1px solid #e4e7ed;
}

.knowledge-card .card-actions {
  display: flex;
  gap: 8px;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #f0f0f0;
}

.knowledge-card .card-actions .el-button {
  flex: 1;
}

.knowledge-card .question-count {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  color: #606266;
  margin-top: 8px;
}

.knowledge-card .question-count i {
  color: #909399;
}

.knowledge-card.is-other {
  border-left: 4px solid #909399;
  background: #fafafa;
}

.knowledge-card.is-other:hover {
  border-left-color: #667eea;
}

.knowledge-card.locked {
  background: #f5f7fa;
  opacity: 0.7;
  border-left: 4px solid #f56c6c;
  cursor: not-allowed;
}

.knowledge-card.locked:hover {
  transform: none;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.knowledge-card.locked .knowledge-title {
  color: #909399;
}

.knowledge-card.locked .card-content {
  color: #c0c4cc;
}

</style>
